import SvgCheckCircle from "../../components/icons/CheckCircle";
import SvgDoNotDisturbOn from "../../components/icons/DoNotDisturbOn";
import SvgHelp from "../../components/icons/Help";
import SvgWarning from "../../components/icons/Warning";
import { Translation } from "../../hooks/useTranslations";
import { Glyph } from "../../types";
import { CarTaskNoCarDependency } from "../carTasks/types";
import { User, UserLight } from "../users/types";

export type Workflow = {
  id: string;
  driver: User;
  carTask: CarTaskNoCarDependency;
  author: UserLight;
  createdAt: string;
  stickers?: StickersWorkflow;
  state?: string;
  logs: WorkflowLog[];
};

export type WorkflowLog = {
  id: string;
  author: UserLight;
  createdAt: string;
  action: string;
  notes?: string;
};

export type StickersWorkflow = {
  state: string;
};

type IconProps = { title: string; glyph: Glyph; color?: "red" | "yellow" | "green" | "grey" | "blue" };

export const getIconProps = (t: Translation, state: string, workflowCreatedAt: string): IconProps => {
  const maxDate = new Date(workflowCreatedAt);
  maxDate?.setDate(maxDate.getDate() + 10);
  const today = new Date();

  const map: { [key: string]: IconProps } = {
    pending: {
      title: t.common.waitingUser,
      glyph: SvgWarning,
      color: maxDate && maxDate < today ? "red" : "yellow",
    },
    closed: {
      title: t.common.close,
      glyph: SvgCheckCircle,
      color: "green",
    },
    "image-supplied": {
      title: t.common.imagesSupplied,
      glyph: SvgCheckCircle,
      color: "yellow",
    },
    cancelled: {
      title: t.common.cancelled,
      glyph: SvgDoNotDisturbOn,
      color: "grey",
    },
  };

  return map[state] ?? { title: state, glyph: SvgHelp, color: "yellow" };
};
